import * as React from 'react';
import {
  DashboardAtrasoPorSistema,
  DashboardAtrasoPorSistemaFields,
  DashboardMensajesPorEtapaEstadoFields
} from "../types/dashboard";
import {DefaultizedPieValueType, pieArcLabelClasses, PieChart} from "@mui/x-charts";
import {mangoFusionPalette,} from '@mui/x-charts/colorPalettes';
import CardActions from "../../sistema/components/CardActions";

interface MensajesPorSistemaChartChartProps {
  data: DashboardAtrasoPorSistema[]
}

export default function MensajesPorSistemaChart({data}: MensajesPorSistemaChartChartProps) {
  const getArcLabel = (params: DefaultizedPieValueType) => {
    const total = data?.map(x => x[DashboardMensajesPorEtapaEstadoFields.CantMensajes]).reduce((a, b) => a + b, 0)
    const percent = params.value / total

    return `${(percent * 100).toFixed(0)}%`
  };

  return (
    <CardActions title={'Mensajes por Sistema'}
                 colapsable
    >

      <PieChart
        margin={{right: 150}}
        dataset={data}
        colors={mangoFusionPalette}
        series={[
          {
            outerRadius: 120,
            innerRadius: 50,
            paddingAngle: 1,
            data: data?.map(x => ({
              id: x.id,
              value: x[DashboardAtrasoPorSistemaFields.CantMensajes],
              label: x[DashboardAtrasoPorSistemaFields.Sistema],
            })),
            arcLabel: getArcLabel,
            arcLabelMinAngle: 10,
          },
        ]}
        slotProps={{
          legend: {
            labelStyle: {
              fontSize: 14,
            },
            direction: 'column',
            position: {
              vertical: 'middle',
              horizontal: 'right',
            },
            itemMarkWidth: 20,
            itemMarkHeight: 20,
            markGap: 5,
            itemGap: 10,
          }
        }}
        sx={{
          [`& .${pieArcLabelClasses.root}`]: {
            fill: 'white',
            fontSize: 14,
          },
        }}
        width={600}
        height={400}
      />
    </CardActions>
  );
}